module.exports = __webpack_public_path__ + "media/images/pc/top/area_brand_suns@2x-f42faab45097d62e393aac8a050f3622.webp";